import { render, staticRenderFns } from "./ProjectProposalFormB.vue?vue&type=template&id=9aa2c856&"
import script from "./ProjectProposalFormB.vue?vue&type=script&lang=ts&"
export * from "./ProjectProposalFormB.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectProposalFormB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports